"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountValidationErrorCodes = void 0;
var DiscountValidationErrorCodes;
(function (DiscountValidationErrorCodes) {
    DiscountValidationErrorCodes[DiscountValidationErrorCodes["AlreadyUsed"] = 0] = "AlreadyUsed";
    DiscountValidationErrorCodes[DiscountValidationErrorCodes["Invalid"] = 1] = "Invalid";
})(DiscountValidationErrorCodes || (exports.DiscountValidationErrorCodes = DiscountValidationErrorCodes = {}));
//# sourceMappingURL=DiscountValidationErrorCodes.js.map